window.addEventListener('load', function () {
    function ApplyCasinoAndGamesLogin(param1, param2, param3, param4) {
        if (param1 != null) {
            TicketID = param1;
        }

        if (param2 != null) {
            CTXMGameMode = param2;
        }

        if (UserInfo) {
            CTXMGameMode = 'real';
        }
        else {
            CTXMGameMode = 'fun';
        }


        if (param3 != null) {
            CTXMMerchURL = param3;
        }

        if (param4 != null) {
            CTXMMerchID = param4;
        }
    }

    function ApplyNewCasinoLogin(param1, param2) {
        if (param1 != null) {
            MGSToken = param1;
        }

        if (param2 != null) {
            MGSURL = param2;
        }
    }

    function iterateChosenBetHTML(el) {
        var selectedElement = el.getAttribute('id');
        if (selectedElement == 'loginButton' || selectedElement == 'registerButton') {
            return;
        }

        var oddSelectClass = '';
        for (var i = 0; i < el.classList.length; i += 1) {
            if (el.classList.item(i).startsWith(getUniqueOddsClassPrefix())) {
                oddSelectClass = el.classList.item(i);
                break;
            }
        }

        if (!el.classList.contains('chosenBet')) {
            var maxRegularLinesCountsError = $dict.bs("MaxRegularLinesCounts").format(BetSlip.maxSelectionsNumber);
            if (Array.getLength(BetSlip.Selections) <= BetSlip.maxSelectionsNumber && BetSlip.CurrentMode.CurrentError !== maxRegularLinesCountsError) {
                addRemoveChosenBetClassByDataParams(oddSelectClass, el, true);
            }
            else {
                alert(maxRegularLinesCountsError);

            }
        }
        else {
            addRemoveChosenBetClassByDataParams(oddSelectClass, el, false);
        }

    };

    function betButtonCallback(e) {
        if (e.target.classList.contains('bet_btn') || e.target.classList.contains('bet-button') || e.target.classList.contains('rj-ev-list__bet-btn')) {
            iterateChosenBetHTML(e.target);
        }
    }
    
    function addRemoveChosenBetClassByDataParams(selector, element, add) {
        if (BetSlip.IsInEditMode) {
            return;
        }
    
        if (add) {
            BetSlipAnimatedOddsAdd(element);
        }
        else {
            element.classList.remove('chosenBet');
        }
    
        if (!selector) {
            return;
        }
    
        var elements = document.getElementsByClassName(selector);
        if (elements) {
            for (var i = 0; i < elements.length; i += 1) {
                add ? elements[i].classList.add('chosenBet') : elements[i].classList.remove('chosenBet');
            }
        }
    }    

    document.body.addEventListener('click', betButtonCallback);

    UserInfo.onCommand['JSCommands'] = function (sender, data) {
        if ('functionCall' in data) {
            if (data.functionCall == 'googleAnalytics') {
                SendToGoogleAnalytics.apply(data.params);
            }
            else if (data.functionCall == 'CasinoAndGamesLogin') {
                ApplyCasinoAndGamesLogin(data.params[0], data.params[1], data.params[2], data.params[3]);
            }
            else if (data.functionCall == 'NewCasinoLogin') {
                ApplyNewCasinoLogin(data.params[0], data.params[1]);
            }
        }
    };

    UserInfo.onCommand['DynamicPixels'] = function (sender, data) {
        if (data && data.functionCall == 'successfulDepositEvent') {
            addDynamicPixels(data.MessageParams);
        }
    };

    UserInfo.onCommand['EpsStatisticEvents'] = function (sender, data) {
        if (data && 'functionCall' in data && data.functionCall === 'EpsStatisticEvent') {
            if (UseGoogleTagManager) {
                try {
                    var epsEvent = {
                        'event': data.eventType
                    };
                    epsEvent[data.eventItemsTitle] = JSON.parse(data.eventItems);

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push(epsEvent);
                }
                catch (exception) {
                    console.log(exception.message);
                }
            }
        }
    }

    UserInfo.onLogin['global'] = function () {
        document.body.classList.remove('nouserdata', 'notlogged');
        document.body.classList.add('loggedin');
        //$(document.body).removeClass('nouserdata').removeClass('notlogged').addClass('loggedin');
    };

    UserInfo.onLogout['global'] = function () {
        document.body.classList.remove('nouserdata', 'loggedin');
        document.body.classList.add('notlogged');
        //$(document.body).removeClass('nouserdata').removeClass('loggedin').addClass('notlogged');
        ToggleMainNavigation.hide();
        Application.rightNavPanelsHolder.hide();
    };

    UserInfo.onNotLoggedIn['global'] = function () {
        document.body.classList.remove('nouserdata');
        document.body.classList.add('notlogged');
        return;
    };
});
